var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSquareBackground(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 391,
    height: 175,
    viewBox: "0 0 391 175",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.775,
    y: 1.775,
    width: 56.45,
    height: 56.45,
    stroke: "#B0B0B0",
    strokeWidth: 3.55
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 58.2252,
    y: 1.775,
    width: 56.45,
    height: 56.45,
    stroke: "#B0B0B0",
    strokeWidth: 3.55
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 114.675,
    y: 1.775,
    width: 56.45,
    height: 56.45,
    stroke: "#B0B0B0",
    strokeWidth: 3.55
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 171.125,
    y: 1.775,
    width: 56.45,
    height: 56.45,
    stroke: "#B0B0B0",
    strokeWidth: 3.55
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 227.575,
    y: 1.775,
    width: 56.45,
    height: 56.45,
    stroke: "#B0B0B0",
    strokeWidth: 3.55
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 284.025,
    y: 1.775,
    width: 56.45,
    height: 56.45,
    stroke: "#B0B0B0",
    strokeWidth: 3.55
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 340.475,
    y: 1.775,
    width: 56.45,
    height: 56.45,
    fill: "#939393",
    fillOpacity: 0.25,
    stroke: "#B0B0B0",
    strokeWidth: 3.55
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 1.775,
    y: 58.225,
    width: 56.45,
    height: 56.45,
    stroke: "#B0B0B0",
    strokeWidth: 3.55
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 58.2252,
    y: 58.225,
    width: 56.45,
    height: 56.45,
    stroke: "#B0B0B0",
    strokeWidth: 3.55
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 114.675,
    y: 58.225,
    width: 56.45,
    height: 56.45,
    stroke: "#B0B0B0",
    strokeWidth: 3.55
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 171.125,
    y: 58.225,
    width: 56.45,
    height: 56.45,
    stroke: "#B0B0B0",
    strokeWidth: 3.55
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 227.575,
    y: 58.225,
    width: 56.45,
    height: 56.45,
    stroke: "#B0B0B0",
    strokeWidth: 3.55
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 284.025,
    y: 58.225,
    width: 56.45,
    height: 56.45,
    stroke: "#B0B0B0",
    strokeWidth: 3.55
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 340.475,
    y: 58.225,
    width: 56.45,
    height: 56.45,
    stroke: "#B0B0B0",
    strokeWidth: 3.55
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 1.775,
    y: 114.675,
    width: 56.45,
    height: 56.45,
    stroke: "#B0B0B0",
    strokeWidth: 3.55
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 58.2252,
    y: 114.675,
    width: 56.45,
    height: 56.45,
    stroke: "#B0B0B0",
    strokeWidth: 3.55
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 114.675,
    y: 114.675,
    width: 56.45,
    height: 56.45,
    stroke: "#B0B0B0",
    strokeWidth: 3.55
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 171.125,
    y: 114.675,
    width: 56.45,
    height: 56.45,
    stroke: "#B0B0B0",
    strokeWidth: 3.55
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 227.575,
    y: 114.675,
    width: 56.45,
    height: 56.45,
    fill: "#939393",
    fillOpacity: 0.25,
    stroke: "#B0B0B0",
    strokeWidth: 3.55
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 284.025,
    y: 114.675,
    width: 56.45,
    height: 56.45,
    stroke: "#B0B0B0",
    strokeWidth: 3.55
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 340.475,
    y: 114.675,
    width: 56.45,
    height: 56.45,
    fill: "#939393",
    fillOpacity: 0.25,
    stroke: "#B0B0B0",
    strokeWidth: 3.55
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquareBackground);
export default __webpack_public_path__ + "static/media/square_background.c0d1718a7fbb605ceb6ebee5b6ae9448.svg";
export { ForwardRef as ReactComponent };